import Record from './base'
import moment from 'moment'

export class Engagement extends Record {
  constructor(...args) {
    super(...args)
    this.sortable_date = moment(this.timestamp).valueOf()
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/engagement.js